import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { phoneNumber } from '~/ui/constants/validation';

const validationSchema = object().shape({
  phone: phoneNumber.required('Field is required'),
});

export default yupResolver(validationSchema);
